import { throttle } from "lodash-es";

window.addEventListener("DOMContentLoaded", () => {
  function fixBtnBack() {
    const btnBack = document.querySelector(".js-btn-back");
    if (!btnBack) return;
    const footer = document.querySelector(".l-footer");
    if (footer.getBoundingClientRect().top < window.innerHeight) {
      btnBack.style.bottom = `${window.innerHeight - footer.getBoundingClientRect().top + 20}px`;
    } else {
      btnBack.style.bottom = "";
    }
  }

  window.addEventListener(
    "scroll",
    throttle(() => {
      if (window.innerWidth > 768) {
        fixBtnBack();
      }
    }, 50)
  );
});
